import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import PaymentModeActions, { paymentModeActionTypes } from '../../actions/configurations/paymentModeAction';
import PaymentModeServices from '../../services/configurations/paymentModeServices';

/**
 * @param action
 */

function* _createPaymentMode(action) {
  try {
    yield put(PaymentModeActions.createPaymentModeLoading(true));
    const { payload } = action;
    const paymentMode = yield PaymentModeServices.createPaymentMode(payload);
    if (!paymentMode.success) {
      notification.open({
        type: 'error',
        message: paymentMode?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: paymentMode?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(PaymentModeActions.createPaymentModeLoading(false));
  } catch (error) {
    yield put(PaymentModeActions.createPaymentModeLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */

function* createPaymentMode() {
  yield takeLatest(paymentModeActionTypes.CREATE_PAYMENT_MODE.REQUEST, _createPaymentMode);
}

function* _updatePaymentMode(action) {
  try {
    yield put(PaymentModeActions.updatePaymentModeLoading(true));
    const { payload } = action;
    const paymentMode = yield PaymentModeServices.updatePaymentMode(payload);
    if (!paymentMode.success) {
      notification.open({
        type: 'error',
        message: paymentMode?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: paymentMode?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(PaymentModeActions.updatePaymentModeLoading(false));
  } catch (error) {
    yield put(PaymentModeActions.updatePaymentModeLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */

function* updatePaymentMode() {
  yield takeLatest(paymentModeActionTypes.UPDATE_PAYMENT_MODE.REQUEST, _updatePaymentMode);
}

/**
 *
 */

function* _getPaymentMode(action) {
  try {
    yield put(PaymentModeActions.getPaymentModeLoading(true));
    const { accountType } = action;
    const paymentMode = yield PaymentModeServices.getPaymentMode(accountType);
    if (!paymentMode.success) {
      notification.open({
        type: 'error',
        message: paymentMode?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(PaymentModeActions.getPaymentModeSuccess(paymentMode?.data));
    }
    yield put(PaymentModeActions.getPaymentModeLoading(false));
  } catch (error) {
    yield put(PaymentModeActions.getPaymentModeLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getPaymentMode() {
  yield takeLatest(paymentModeActionTypes.GET_PAYMENT_MODES.REQUEST, _getPaymentMode);
}

function* _deletePaymentMode(action) {
  try {
    yield put(PaymentModeActions.deletePaymentModeLoading(true));
    const { payload } = action;
    const paymentMode = yield PaymentModeServices.deletePaymentMode(payload);
    if (!paymentMode.success) {
      notification.open({
        type: 'error',
        message: paymentMode?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: paymentMode?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(PaymentModeActions.deletePaymentModeLoading(false));
  } catch (error) {
    yield put(PaymentModeActions.deletePaymentModeLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}
/**
 *
 */

function* deletePaymentMode() {
  yield takeLatest(paymentModeActionTypes.DELETE_PAYMENT_MODE.REQUEST, _deletePaymentMode);
}

export default function* PaymentModeSaga() {
  yield all([
    createPaymentMode(),
    updatePaymentMode(),
    getPaymentMode(),
    deletePaymentMode(),
  ]);
}
